module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"addItem":"Добавить размер","size":"Размер","name":"Название","create":"Создать","save":"Сохранить","close":"Закрыть"},"uk":{"addItem":"Додати розмір","size":"Розмір","name":"Название","create":"Створити","save":"Зберегти","close":"Закрити"}}')
  delete Component.options._Ctor
}
